import { countUniquePageVisitsOnSessionId } from '../queries/countUniquePageVisitsOnSessionId'

export const totalKbVisitsGauge = {
  queries: [countUniquePageVisitsOnSessionId],
  title: 'Total visits',
}
